import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import ScreenLoaderContainer from '../portal/controls/screenLoaderContainer';
import PortalToastrContainer from '../portal/portalToastrContainer';
import UsersGrid from './usersGrid';

@inject('translationsStore', 'usersStore', 'teamsStore', 
    'rolesStore', 'addEditUserStore', 'systemLocalesStore') @observer
export default class UsersGridContainer extends Component {

    componentDidMount() {
        
        this.props.usersStore.getAllUsers();
        this.props.teamsStore.getAllTeams();
        this.props.rolesStore.getAllRoles();
        this.props.systemLocalesStore.getSystemLocales();
    }

    render(){
        let grid = null;

        if (this.props.usersStore.users === undefined || 
                this.props.teamsStore.teams === undefined || 
                    this.props.rolesStore.roles === undefined || 
                        this.props.systemLocalesStore.languages === undefined) {

            grid = <ScreenLoaderContainer />;
        }
        else {
            
            grid = <UsersGrid />;
        }
        
        return (
            <div className='users-main-wrapper'>
                <PortalToastrContainer />
                {grid}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/users/usersGridContainer.jsx